import _ from 'lodash';
import React from 'react';
import Select from 'react-select';
import MultimidiaModal from './MultimidiaModal';

export default class MultimidiaBase extends React.Component { 

	constructor() {
		super();

		this.title = "No Title";
		this.groups = [];
		this.state = {
			selectedGroup: {},
			selectedVideo: "",
			isModalOpen: false
		};
	}

	componentDidMount() {
		this.setState({selectedGroup: _.first(this.groups)});
	}

	renderSelect() {
		return this.groups.length > 1 
		? (
			<div className='select-group'>
				<div><b>Grupo:</b></div>
				<Select
					name="multimedia-group-select"
					valueKey="id"
					labelKey="name"
					value={this.state.selectedGroup}	
					options={this.groups}									
					noResultsText="Nenhum resultado encontrado"
					placeholder="Selecione..."
					isRequired
					clearable={false}
					searchable={false}
					onChange={(item) => this.setState({selectedGroup: item})}
				/>
			</div>
		)
		: null;
	}

	renderCoordinators() {
		const { coordinators } = this.state.selectedGroup;
		return coordinators 
		? (
			<p className='coordinators'><b>Coordenadores:</b> {coordinators}</p>
		) 
		: null;
	}

	showVideo(videoId) {
		this.setState({
			selectedVideo: videoId,
			isModalOpen: true
		});
	}

	hideVideo() {
		this.setState({
			selectedVideo: "",
			isModalOpen: false
		});
	}

	renderSelectedGroup() {
		const { videos } = this.state.selectedGroup;
		if (!videos) return;
		return (
			<div className='multimidia-videos'>
				{videos.map((video, key) => {
					return (
						<div key={key} className="video">
							<div className="thumb" >
								<img 
									src={video.imgur} 
									onClick={() => this.showVideo(video.videoID)} 
								/>
							</div>

							<div className="description">
								<b>Descrição</b>
								<br />
								<br />
								
								<b>{video.titulo}</b>
								<br />
								
								<b>Período:</b>{video.periodo} 
								<br />

								<b>Método:</b>{video.metodo}
								<br />
							</div>
						</div>
					);
				})}
			</div>
		);
	}

	render() {
		const { title } = this;
		const { selectedVideo, isModalOpen } = this.state;

		return (
			<div className="row">
				<div className="col-sm-12">
					<div className="panel panel-default">
						<div className="panel-body">

							<div className='multimidia'>
								<h2>{title}</h2>
								<hr />
								<div className='multimidia-content'>
									<p className='descricao'>
										Nesta sessão são disponibilizados os arquivos multimídias da
										distribuição espacial e temporal de alguns parâmetros avaliados pelos grupos da COPPE.
									</p>

									{this.renderSelect()}
									{this.renderCoordinators()}
									{this.renderSelectedGroup()}

								</div>

								<MultimidiaModal
									isOpen={isModalOpen}
									onClose={() => this.hideVideo()}
									videoID={selectedVideo} 
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Multimidia/MultimidiaBase.js